module.exports = __webpack_public_path__ + "img/hintTablex.47279e37.png";